<div class="iq-nav-bar--logo-container" (click)="navigateHome()">
  <div class="iq-flexigroup-logo iq-nav-bar--logo"></div>
</div>
